var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86762 13C2.81159 13 2.75556 12.9727 2.69953 12.9454C2.61548 12.8908 2.55945 12.7542 2.58747 12.645L3.82012 8.16597L0.122164 5.2437C0.0101044 5.18908 -0.0179104 5.05252 0.0101044 4.94328C0.0381192 4.83403 0.150178 4.7521 0.262238 4.7521L5.02476 4.5063L6.73366 0.163866C6.78969 0.0819328 6.90175 0 7.01381 0C7.12587 0 7.23793 0.0819328 7.26594 0.163866L8.97484 4.5063L13.7374 4.7521C13.8494 4.7521 13.9615 4.83403 13.9895 4.94328C14.0175 5.05252 13.9895 5.16176 13.9055 5.2437L10.2075 8.16597L11.4401 12.645C11.4682 12.7542 11.4401 12.8634 11.3281 12.9454C11.244 13 11.104 13.0273 11.0199 12.9454L7.01381 10.4328L3.00769 12.9454C2.95166 13 2.92364 13 2.86762 13Z",
    fill: "#62AA51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarImage);
export default __webpack_public_path__ + "static/media/StarImage.b4aeb7e73c55c9e8c9fc08a6663556aa.svg";
export { ForwardRef as ReactComponent };